/**
 * @jsxRuntime classic
 * @jsx jsx
 */
/** @jsxFrag */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { useIntl } from 'react-intl-next';
import Lozenge from '@atlaskit/lozenge';
import { Box, Text } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';
import messages from './messages';
import { footerInformationStyles, footerStyles } from './styles';
// TODO: Remove during platform_editor_ai_command_palette_post_ga cleanup
export var FooterOld = function FooterOld(_ref) {
  var showBetaLozenge = _ref.showBetaLozenge,
    disclaimer = _ref.disclaimer,
    additionalFooterText = _ref.additionalFooterText,
    footerRightContent = _ref.footerRightContent;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return (
    // eslint-disable-next-line react/react-in-jsx-scope, @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
    jsx("div", {
      css: footerStyles
    }, jsx("div", {
      css: footerInformationStyles
    }, showBetaLozenge && jsx(Lozenge, {
      testId: "beta-lozenge",
      appearance: "inprogress"
    }, formatMessage(messages.betaLabel)), disclaimer ? jsx(Box, {
      testId: "custom-disclaimer"
    }, jsx(Tooltip, {
      content: disclaimer.tooltip,
      position: "top"
    }, disclaimer.url ? jsx("a", {
      href: disclaimer.url,
      target: "_blank",
      rel: "noopener noreferrer"
    }, disclaimer.text) : jsx("span", null, disclaimer.text))) : jsx(Text, {
      as: "p"
    }, formatMessage(messages.disclaimer) + ' ', jsx("a", {
      href: "https://www.atlassian.com/trust/atlassian-intelligence",
      target: "_blank",
      rel: "noopener noreferrer"
    }, formatMessage(messages.disclaimerLink)), additionalFooterText && jsx(Text, {
      as: "strong"
    }, ". ", additionalFooterText))), footerRightContent)
  );
};